// extracted by mini-css-extract-plugin
export default {"container":"Box--container--001c66","section":"Box--section--de4d15","separator":"Box--separator--4f1fd6"};